import { useState } from "react";
import { PixelRatio, StyleSheet, View } from "react-native";
import WebView from "react-native-webview";
import { Page } from "~/components/layout/Page";
import { SectionHeader } from "~/components/layout/SectionHeader";
import { BodyText } from "~/components/layout/text";
import { QendoLogo } from "~/components/QendoLogo";
import { QENDO_LINKS } from "~/constants/environment";
import { Gap } from "~/constants/layout";
import { setDimensionsOnLayout } from "~/util/layout";

export default function ManageEndo() {
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const onLayout = setDimensionsOnLayout(setDimensions);
    const width = PixelRatio.getPixelSizeForLayoutSize(dimensions.width);
    const height = PixelRatio.getPixelSizeForLayoutSize(dimensions.height);

    return (
        <Page spacer scrollable={false}>
            <SectionHeader header={<QendoLogo size={32} />} title="Manage Endo" subtitle="Video series">
                <View style={Gap.xs}>
                    <BodyText size="md">
                        The information and tools you need to manage the symptoms of endometriosis and persistent pelvic
                        pain.
                    </BodyText>
                    <BodyText size="md">Designed by the community, for the community.</BodyText>
                    <BodyText size="md">
                        Our co-designed expert-led ManageEndo program will equip you with the knowledge and tools you
                        need for better management and empowerment in your journey with endometriosis and pelvic pain.
                    </BodyText>
                    <BodyText size="md">Over 20 in-depth tools and strategies & unlimited access.</BodyText>
                </View>
            </SectionHeader>
            <View style={styles.container} onLayout={onLayout}>
                {width > 0 && height > 0 && (
                    <WebView
                        style={dimensions}
                        scrollEnabled={false}
                        overScrollMode="never"
                        baseUrl="https://www.youtube.com/embed/"
                        source={{ uri: QENDO_LINKS.manage_endo_embed }}
                    />
                )}
            </View>
        </Page>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
